import { Wrapper, BreakdownContentWrapper, Text, Divider, SubText, CloseBtn, CloseWrapper, CloseButton } from "./NightlyPriceBreakdownPopupStyling";
import useClickOutside from "../../hook/useClickOutside";
import AnimationWrapperForPopup from "../animationWrapper/AnimationWrapperForPopup";
import { BookingDetailsResponse } from "../../pages/createBooking/createBooking";
import { BookingDetail } from "../../interfaces/models/bookingDetail";
import moment from "moment";

// Adapter function to handle both old and new response types
type BookingDetailsType = BookingDetail | BookingDetailsResponse;

function isBookingDetailsResponse(details: BookingDetailsType): details is BookingDetailsResponse {
    return 'guestBreakdown' in details;
}

function getPriceItems(details: BookingDetailsType) {
    return details.guestBreakdown.priceItems;
}

interface NightlyPriceBreakdownPopupProps {
    bookingDetails: BookingDetailsType;
    toggleModal: () => void;
}



const NightlyPriceBreakdownPopup: React.FC<NightlyPriceBreakdownPopupProps> = ({ bookingDetails, toggleModal }) => {
    const wrapperRef = useClickOutside(true, toggleModal, "click");
    return (
        <>
            {window.innerWidth < 768 ? (
                <div
                    style={{
                        height: "100vh",
                        width: "100vw",
                        position: "fixed",
                        left: 0,
                        top: 0,
                        zIndex: 101,
                        background: "rgba(0, 0, 0, 0.25)",
                        backdropFilter: "blur(0px)",
                    }}
                    id={"loading-full-page-small-modal"}
                    onClick={toggleModal}
                >
                    <AnimationWrapperForPopup>
                        <Wrapper>
                            {getPriceItems(bookingDetails).map((item, index) => (
                                <BreakdownContentWrapper key={item.label}>
                                    <Text>{item.label}</Text>
                                    <Text>{item.amountFormatted}</Text>
                                </BreakdownContentWrapper>
                            ))}
                            <Divider />
                            <SubText>
                                Price shown is your final price <br />
                                including taxes and fees.
                            </SubText>
                            <CloseButton onClick={toggleModal}>Done</CloseButton>
                        </Wrapper>
                    </AnimationWrapperForPopup>
                </div>
            ) : (
                <Wrapper onClick={toggleModal} ref={wrapperRef}>
                    {getPriceItems(bookingDetails).map((item, index) => (
                        <BreakdownContentWrapper key={item.label}>
                            <Text>{item.label}</Text>
                            <Text>{item.amountFormatted}</Text>
                        </BreakdownContentWrapper>
                    ))}
                    <Divider />
                    <SubText>
                        Price shown is your final price <br />
                        including taxes and fees.
                    </SubText>
                </Wrapper>
            )}
        </>
    );
};

export default NightlyPriceBreakdownPopup;
